<template>
  <div class="pt-3 px-3">
    <div class="col-12">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="ativos-tab"
            data-bs-toggle="tab"
            data-bs-target="#ativos"
            type="button"
            role="tab"
            aria-controls="ativos"
            aria-selected="true"
          >
            {{ $t('activeStudents') }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="inativos-tab"
            data-bs-toggle="tab"
            data-bs-target="#inativos"
            type="button"
            role="tab"
            aria-controls="inativos"
            aria-selected="true"
          >
            {{ $t('inactiveStudents') }}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade active show"
          id="ativos"
          role="tabpanel"
          aria-labelledby="ativos-tab"
        >
          <div class="card border-top-start-radius-0 border-top-end-radius-0">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Card header -->
                  <div class="pb-0 card-header">
                    <div class="d-lg-flex">
                      <div>
                        <h5 class="mb-0">{{ $t('allStudents') }}</h5>
                        <p class="mb-0 text-sm">{{ $t('studentList') }}</p>
                      </div>
                      <div class="my-auto mt-4 ms-auto mt-lg-0">
                        <div class="my-auto ms-auto">
                          <button
                            type="button"
                            class="mb-0 btn bg-gradient-success btn-sm"
                            @click="formularioAluno()"
                          >
                            +&nbsp; {{ $t('newStudent') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <MyTable
                      v-if="isVisible"
                      :data="state.alunosAtivos"
                      :columns="columns"
                      :itemsPerPage="12"
                    >
                      <template v-slot:row="{ row }">
                        <td class="text-sm pointer">{{ row.name }} {{ row.surname }}</td>
                        <td class="text-sm text-center">
                          <template v-if="row.cep == null">
                            {{ row.cep }}
                          </template>
                          <template v-else>
                            <span class="font-weight-bold">{{ $t('zipCode') }}: </span>{{ row.cep
                            }}<br />
                            {{ row.street }}, {{ row.number }} <br />
                            {{ row.neighborhood }} <br />
                            {{ row.city }}/{{ row.state }}<br />
                          </template>
                        </td>
                        <td class="text-sm text-center">
                          <span class="font-weight-bold">{{ $t('email') }}: </span>{{ row.email
                          }}<br />
                          <span class="font-weight-bold">{{ $t('phone') }}: </span>{{ row.phone }}
                        </td>
                        <td class="text-sm text-center">{{ $filters.datePtbr(row.created_at) }}</td>
                        <td class="text-sm">
                          <div class="float-end">
                            <div>
                              <span
                                class="pointer"
                                title="{{ $t('editStudent') }}"
                                @click="formularioAluno(row.id)"
                              >
                                <i class="fas fa-pen text-secondary me-2"></i> {{ $t('edit') }}
                              </span>
                            </div>
                            <div>
                              <span
                                class="pointer"
                                title="{{ $t('deleteStudent') }}"
                                @click="deletarAluno(row)"
                              >
                                <i class="fas fa-trash text-secondary me-2"></i>
                                {{ $t('inactive') }}
                              </span>
                            </div>
                          </div>
                        </td>
                      </template>
                    </MyTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade show"
          id="inativos"
          role="tabpanel"
          aria-labelledby="inativos-tab"
        >
          <div class="card border-top-start-radius-0 border-top-end-radius-0">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <MyTable
                      v-if="isVisible"
                      :data="state.alunosInativos"
                      :columns="columns"
                      :itemsPerPage="12"
                    >
                      <template v-slot:row="{ row }">
                        <td class="text-sm pointer">{{ row.name }} {{ row.surname }}</td>
                        <td class="text-sm text-center">
                          <template v-if="row.cep == null">
                            {{ row.cep }}
                          </template>
                          <template v-else>
                            <span class="font-weight-bold">{{ $t('zipCode') }}: </span>{{ row.cep
                            }}<br />
                            {{ row.street }}, {{ row.number }} <br />
                            {{ row.neighborhood }} <br />
                            {{ row.city }}/{{ row.state }}<br />
                          </template>
                        </td>
                        <td class="text-sm text-center">
                          <span class="font-weight-bold">{{ $t('email') }}: </span>{{ row.email
                          }}<br />
                          <span class="font-weight-bold">{{ $t('phone') }}: </span>{{ row.phone }}
                        </td>
                        <td class="text-sm text-center">{{ $filters.datePtbr(row.created_at) }}</td>
                        <td class="text-sm">
                          <div class="float-end">
                            <div>
                              <span
                                class="pointer"
                                title="{{ $t('editStudent') }}"
                                @click="formularioAluno(row.id)"
                              >
                                <i class="fas fa-pen text-secondary me-2"></i> {{ $t('edit') }}
                              </span>
                            </div>
                            <div>
                              <span
                                class="pointer"
                                title="{{ $t('activateStudent') }}"
                                @click="reativarAluno(row)"
                              >
                                <i class="fas fa-check text-success me-2"></i> {{ $t('active') }}
                              </span>
                            </div>
                            <div>
                              <span
                                class="pointer"
                                title="Excluir permanentemente"
                                @click="excluirPermanentemente(row)"
                              >
                                <i class="fas fa-trash-alt text-danger me-2"></i> Excluir
                              </span>
                            </div>
                          </div>
                        </td>
                      </template>
                    </MyTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n' // Import useI18n
import alunoRepository from '../../../../services/api/alunoRepository'
import MyTable from '../../../../components/MyTable.vue'
import { useRouter } from 'vue-router'
import AlunoFormulario from './AlunoCadastro.vue'

export default {
  components: {
    MyTable,
    AlunoFormulario,
  },
  setup() {
    const { t } = useI18n() // Initialize useI18n and get the `t` function
    const router = useRouter()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      store.commit('SET_SPLASH_SCREEN', false)
      listarAlunos()
    })

    let isVisible = ref(false)
    const columns = ref([
      { label: t('name'), field: 'name', sortable: 'name' },
      { label: t('address'), field: 'address', sortable: '' },
      { label: t('contact'), field: 'contact', sortable: '' },
      { label: t('registrationDate'), field: 'created_at' },
      { label: t('actions'), field: 'actions' },
    ])

    const state = reactive({
      alunoId: 0,
      alunosAtivos: [],
      alunosInativos: [],
    })

    const listarAlunos = () => {
      store.commit('SET_SPLASH_SCREEN', true)

      // Buscar alunos ativos e inativos em paralelo
      Promise.all([
        alunoRepository.AlunoGet(),
        alunoRepository.AlunoGetInativos()
      ])
        .then(([ativosResponse, inativosResponse]) => {
          store.commit('SET_SPLASH_SCREEN', false)

          if (ativosResponse.data.success) {
            state.alunosAtivos = ativosResponse.data.data
          }

          if (inativosResponse.data.success) {
            state.alunosInativos = inativosResponse.data.data
          }

          isVisible.value = true // Torna as tabelas visíveis após o carregamento
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorListingStudents'),
            text: error.message,
          })
        })
    }

    function formularioAluno(id = 0) {
      state.alunoId = id
      router.push(id !== 0 ? `/alunos/cadastro/${id}` : '/alunos/cadastro')
    }

    function deletarAluno(item) {
      swal({
        title: t('areYouSure'),
        text: t('deactivateConfirmation', { name: item.name }),
        showCancelButton: true,
        confirmButtonText: t('yesDeactivate'),
        cancelButtonText: t('noCancel'),
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          deletarAlunoConfirma(item.id)
        }
      })
    }

    function deletarAlunoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoRepository
        .AlunoDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: t('deactivated'),
              text: t('studentDeactivatedSuccessfully'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              state.alunosAtivos = state.alunosAtivos.filter((aluno) => aluno.id !== id)
              state.alunosInativos = state.alunosInativos.filter((aluno) => aluno.id !== id)
              listarAlunos() // Recarregar a lista após a exclusão
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorDeactivatingStudent'),
            text: error.message,
          })
        })
    }

    function reativarAluno(item) {
      swal({
        title: t('areYouSure'),
        text: t('activateConfirmation', { name: item.name }),
        showCancelButton: true,
        confirmButtonText: t('yesActivate'),
        cancelButtonText: t('noCancel'),
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          reativarAlunoConfirma(item.id)
        }
      })
    }

    function reativarAlunoConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoRepository
        .AlunoRestore(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: t('activated'),
              text: t('studentActivatedSuccessfully'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              listarAlunos() // Recarregar a lista após a reativação
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: t('errorActivatingStudent'),
            text: error.message,
          })
        })
    }

    function excluirPermanentemente(item) {
      swal({
        title: 'Excluir permanentemente?',
        html: `<p>Você está prestes a excluir <strong>${item.name}</strong> permanentemente do sistema.</p>
               <p class="text-danger"><strong>Esta ação é IRREVERSÍVEL!</strong></p>
               <p>Todos os dados do aluno serão perdidos.</p>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir permanentemente',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-danger',
          cancelButton: 'btn bg-gradient-secondary',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // Segunda confirmação
          swal({
            title: 'Confirmação final',
            text: `Digite o nome "${item.name}" para confirmar a exclusão:`,
            input: 'text',
            inputPlaceholder: 'Digite o nome do aluno',
            showCancelButton: true,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            customClass: {
              confirmButton: 'btn bg-gradient-danger',
              cancelButton: 'btn bg-gradient-secondary',
            },
            buttonsStyling: false,
            inputValidator: (value) => {
              if (value !== item.name) {
                return 'O nome digitado não confere!'
              }
            }
          }).then((confirmResult) => {
            if (confirmResult.isConfirmed) {
              excluirPermanentementeConfirma(item.id)
            }
          })
        }
      })
    }

    function excluirPermanentementeConfirma(id) {
      store.commit('SET_SPLASH_SCREEN', true)
      alunoRepository
        .AlunoForceDelete(id)
        .then((response) => {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: 'Excluído!',
              text: 'Aluno excluído permanentemente com sucesso.',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            }).then(() => {
              listarAlunos() // Recarregar a lista
            })
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          swal({
            icon: 'error',
            title: 'Erro ao excluir',
            text: error.response?.data?.message || error.message,
          })
        })
    }

    return {
      state,
      columns,
      deletarAluno,
      formularioAluno,
      isVisible,
      reativarAluno,
      excluirPermanentemente,
    }
  },
}
</script>
